'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { Maximize2 } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '@/shared/components/ui/dialog';
import { cn } from '@/shared/lib/utils';
interface ImageZoomButtonProps {
  src: string;
  className?: string;
}
export function ImageZoomButton(t0) {
  const $ = _c(15);
  const {
    src,
    className
  } = t0;
  const [open, setOpen] = useState(false);
  let t1;
  if ($[0] !== className) {
    t1 = cn("z-10 flex items-center justify-center rounded-full bg-black/60 text-white/90 opacity-0 transition-all group-hover:opacity-100 hover:bg-black/80", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      e.stopPropagation();
      setOpen(true);
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Maximize2 className="h-3 w-3" />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1) {
    t4 = <button type="button" className={t1} onClick={t2} aria-label="Zoom image">{t3}</button>;
    $[4] = t1;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <DialogTitle className="sr-only">Image preview</DialogTitle>;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== src) {
    t6 = <DialogContent className="max-h-[90vh] max-w-[90vw] p-2 sm:max-w-[90vw]" showCloseButton={true}>{t5}<img src={src} alt="Image preview" className="max-h-[calc(90vh-2rem)] w-full rounded-md object-contain" /></DialogContent>;
    $[7] = src;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== open || $[10] !== t6) {
    t7 = <Dialog open={open} onOpenChange={setOpen}>{t6}</Dialog>;
    $[9] = open;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t4 || $[13] !== t7) {
    t8 = <>{t4}{t7}</>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}